import { formHelperTextLocale as formHelperText } from "../FormHelperText/FormHelperText.locale.mjs.mjs";
import { formLabelLocale as formLabel } from "../FormLabel/FormLabel.locale.mjs.mjs";
import { searchLocale as search } from "../Search/Search.locale.mjs.mjs";
import { sliderLocale as slider } from "../Slider/Slider.locale.mjs.mjs";
import { paginationLocale as pagination } from "../Pagination/Pagination.locale.mjs.mjs";
import { datePickerLocale as datePicker } from "../DatePicker/DatePicker.locale.mjs.mjs";
import { popoverLocale as popover } from "../Popover/Popover.locale.mjs.mjs";
import { tagLocale as tag } from "../Tag/Tag.locale.mjs.mjs";
export const en_US = {
    localeIdentifier: 'en-US',
    formHelperText,
    formLabel,
    search,
    slider,
    pagination,
    datePicker,
    popover,
    tag,
};
//# sourceMappingURL=en_US.mjs.mjs.map